import { EParkingType } from '../../../../JsonQuery';

export const PARKING_TYPES_MAP_VALUE_TO_LABEL = {
  [EParkingType.Ground]: 'Наземная',
  [EParkingType.Multilevel]: 'Многоуровневая',
  [EParkingType.Underground]: 'Подземная',
  [EParkingType.Rooftop]: '',
};
